import {Component} from 'react'

import AsyncTypeahead from './AsyncTypeahead.jsx'

import api from '../../../../api.js'

export default class LanguageTypeahead extends Component {
  search = async (query) => {
    if (this.props.currentUniverseId !== null) {
      return (await api.languages.suggest({
        search: query,
      })).data
    }
  }

  static defaultProps = {
    ...AsyncTypeahead.defaultProps,
    promptText: 'Entrez le nom d\'une langue'
  }

  render() {
    const {labelKey, valueField, type, ...rest} = this.props

    return (
      <AsyncTypeahead
        selected={(this.props.input.value ? this.props.input.value : [])}
        onSearch={this.search}
        allowNew={false}
        labelKey="name"
        {...rest} />
    )
  }
}